<template>
    <div class="step">
        <img
            v-if="chosenProgram && chosenProgram.image"
            :src="getProgramImageUrl(chosenProgram.image)"
            :alt="chosenProgram.name"
            class="mb-8 mx-auto"
            style="max-height: 100px"
        />
        <h4 class="text-lg lg:text-2xl text-center mb-8">
            Do You Have Elite Status With
            {{ chosenProgram ? chosenProgram.name : '' }}?
        </h4>
        <select
            class="form-select mx-auto max-w-md mb-5"
            :value="program.has_elite_status"
            @change="$emit('update:has-elite-status', $event.target.value)"
        >
            <option value=""></option>
            <option value="Y">Yes</option>
            <option value="N">No</option>
        </select>
        <div
            class="flex flex-col"
            v-if="program.has_elite_status === 'Y'"
        >
            <h4 class="text-2xl text-center mb-5">
                What Elite Status Do You Have?
            </h4>
            <select
                class="form-select mx-auto max-w-md"
                :value="program.elite_status"
                @change="$emit('update:elite-status', $event.target.value)"
            >
                <option value=""></option>
                <option value="gold">
                    {{ chosenProgram ? chosenProgram.name : '' }} Gold
                </option>
                <option value="platinum">
                    {{ chosenProgram ? chosenProgram.name : '' }} Platinum
                </option>
            </select>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    program: { type: Object, required: true },
    chosenProgram: { type: Object, default: null },
    getProgramImageUrl: { type: Function, required: true },
});

defineEmits(['update:has-elite-status', 'update:elite-status']);
</script>
